import React, {Component} from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

import FadingScroll from 'js/components/fading_scroll';

import './index.scss';

export default class GuidelinesSelectList extends Component {
    static defaultProps = {
        onChange: R.identity
    };

    constructor(props) {
        super(props);
        this.state = {
            guidelines: props.guidelines
        };
    }

    onToggle = id => {
        const guidelines = R.map(
            R.ifElse(
                R.propEq('id', id),
                guideline => R.assoc('selected', !guideline.selected, guideline),
                R.identity
            ),
            this.state.guidelines
        );
        this.setState({guidelines});
        this.props.onChange(guidelines);
    };

    renderGuideline = ({id, guideline, selected}) => {
        const classes = classNames('guidelines-select-list__toggle', {
            'guidelines-select-list__toggle--on': selected
        });
        return (
            <div
                key={id}
                className="guidelines-select-list__guideline"
                onClick={() => this.onToggle(id)}
            >
                <i className={classes} />
                {guideline}
            </div>
        );
    };

    render() {
        const {guidelines} = this.state;
        const selectedCount = R.pipe(
            R.filter(R.propEq('selected', true)),
            R.length
        )(guidelines);
        const countText =
            selectedCount === 1
                ? `${selectedCount} missed guideline selected`
                : `${selectedCount} missed guidelines selected`;

        return (
            <div className="guidelines-select-list">
                <FadingScroll>{R.map(this.renderGuideline, guidelines)}</FadingScroll>
                <div className="guidelines-select-list__count">{countText}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/guidelines_select_list/index.js